<!-- footer -->
<template>
  <div>
    <footerPc></footerPc>
  </div>
</template>

<script>
import footerPc from './components/footerpc'
import footerMobile from './components/footermobile'
export default {
  components: { footerPc, footerMobile }
}
</script>
